/**
 * @description Примесь о внешних контактах.
 */
export default {
  helpEmailHref: 'mailto:help@32top.kz',
  helpEmailTitle: 'help@32top.kz',
  supportEmailHref: 'mailto:zakaz@32top.kz',
  supportEmailTitle: 'zakaz@32top.kz',
  supportPhoneHref: 'tel:+77715476027',
  supportPhoneTitle: '+7 (771) 547-60-27',
  managerPhoneHref: 'tel:+77715476027',
  managerPhoneTitle: '+7 (771) 547-60-27',
  supportTelegramHref: 'https://t.me/mis32topbot',
  supportMaxHref: 'https://max.ru/u/f9LHodD0cOKCWXm5QbVl7bexPQ36qgk46fKu9RiL1REISxfSZgW0VfSC3ic',
  supportWhatsappHref: 'https://wa.me/77715476027/',
  supportManagerName: 'Татьяна',
};
